import { getElectronAPI } from "@org-avp/avp-avengers-ui-framework-electron-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { LicenseManager } from "ag-grid-enterprise";

// side effect: set AG Grid license key
LicenseManager.setLicenseKey(environment.NX_AGGRID_LICENSE_KEY);

getElectronAPI()?.on.messageFromMain((_, text) => {
  console.log(`Received message from Electron Main Tread: ${text}`);
});

// exports for webapp module, consisting only of two calls
export { registerAllViews } from "./app/modules";
export { renderAppShell } from "./render";
